// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.3.1_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.15_5c916327c7a1e0ea96b4ad86b04a02b8/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.3.1_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.15_5c916327c7a1e0ea96b4ad86b04a02b8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eW8e6bezl9oxZKBZ {
  align-items: center;
  gap: var(--lp-spacing-300);
  width: 100%;
  display: flex;
  overflow: hidden;
}

.eW8e6bezl9oxZKBZ:has(input[data-rac]:not([disabled])) {
  cursor: text;
}

.eW8e6bezl9oxZKBZ:has(input[data-rac]:not([disabled])) :where(button, [role="button"]) {
  cursor: default;
}

.eW8e6bezl9oxZKBZ:has([slot="increment"], [slot="decrement"]) {
  gap: 0;
}

.eW8e6bezl9oxZKBZ:has(button[data-rac]) {
  padding-block: 3px;
}

.eW8e6bezl9oxZKBZ[data-focus-within] {
  outline: 2px solid var(--lp-color-shadow-interactive-focus);
  outline-offset: -2px;
  z-index: 1;
}

.eW8e6bezl9oxZKBZ [role="presentation"][data-rac], .eW8e6bezl9oxZKBZ input[data-rac] {
  background-color: inherit;
  border-radius: unset;
  cursor: inherit;
  border: none;
  outline: none;
  padding: 0;
}

.eW8e6bezl9oxZKBZ :where([data-input-slot]) + [data-icon]:not([data-validation-icon]), .eW8e6bezl9oxZKBZ :where(input[data-rac]) + [data-icon]:not([data-validation-icon]) {
  fill: var(--lp-color-fill-ui-secondary);
}

.eW8e6bezl9oxZKBZ input[data-rac]:has( + [data-validation-icon]) {
  padding-inline-end: var(--lp-spacing-700);
}

.eW8e6bezl9oxZKBZ[data-disabled] > :where([data-icon]) {
  opacity: .64;
}
`, "",{"version":3,"sources":["webpack://./../../launchpad-ui/packages/components/src/styles/Group.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2DAA2D;EAC3D,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd","sourcesContent":[".group {\n  align-items: center;\n  gap: var(--lp-spacing-300);\n  width: 100%;\n  display: flex;\n  overflow: hidden;\n}\n\n.group:has(input[data-rac]:not([disabled])) {\n  cursor: text;\n}\n\n.group:has(input[data-rac]:not([disabled])) :where(button, [role=\"button\"]) {\n  cursor: default;\n}\n\n.group:has([slot=\"increment\"], [slot=\"decrement\"]) {\n  gap: 0;\n}\n\n.group:has(button[data-rac]) {\n  padding-block: 3px;\n}\n\n.group[data-focus-within] {\n  outline: 2px solid var(--lp-color-shadow-interactive-focus);\n  outline-offset: -2px;\n  z-index: 1;\n}\n\n.group [role=\"presentation\"][data-rac], .group input[data-rac] {\n  background-color: inherit;\n  border-radius: unset;\n  cursor: inherit;\n  border: none;\n  outline: none;\n  padding: 0;\n}\n\n.group :where([data-input-slot]) + [data-icon]:not([data-validation-icon]), .group :where(input[data-rac]) + [data-icon]:not([data-validation-icon]) {\n  fill: var(--lp-color-fill-ui-secondary);\n}\n\n.group input[data-rac]:has( + [data-validation-icon]) {\n  padding-inline-end: var(--lp-spacing-700);\n}\n\n.group[data-disabled] > :where([data-icon]) {\n  opacity: .64;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"group": `eW8e6bezl9oxZKBZ`
};
export default ___CSS_LOADER_EXPORT___;
